import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { MailIcon, LockIcon, EyeIcon, EyeOffIcon } from 'lucide-react';
interface SignInPageProps {
  onNavigate: (page: string) => void;
}
export function SignInPage({
  onNavigate
}: SignInPageProps) {
  const [showPassword, setShowPassword] = useState(false);
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} exit={{
    opacity: 0,
    y: -20
  }} transition={{
    duration: 0.4
  }} className="min-h-screen bg-cream flex flex-col items-center justify-center py-12 px-4 sm:px-6 lg:px-8" data-id="element-578">
      <div className="max-w-md w-full bg-white rounded-3xl shadow-xl border border-amber/10 p-8" data-id="element-579">
        <div className="text-center mb-8" data-id="element-580">
          <div className="flex justify-center mb-4" data-id="element-581">
            <img src="https://cdn.magicpatterns.com/uploads/64it8njJxRLMTBC7zyqg6G/VICTORY-LOGO-TRANSPARENT.png" alt="Victory Kitchen Z" className="h-16 w-auto" data-id="element-582" />
          </div>
          <h2 className="font-heading text-4xl text-charcoal uppercase tracking-wide" data-id="element-583">
            Sign In
          </h2>
          <p className="font-body text-charcoal/60 mt-2" data-id="element-584">
            Welcome back to Victory Kitchen Z
          </p>
        </div>

        <form className="space-y-6" onSubmit={e => e.preventDefault()} data-id="element-585">
          <div data-id="element-586">
            <label className="block font-heading text-sm text-charcoal uppercase tracking-wide mb-2" data-id="element-587">
              Email Address
            </label>
            <div className="relative" data-id="element-588">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-589">
                <MailIcon className="h-5 w-5 text-charcoal/40" data-id="element-590" />
              </div>
              <input type="email" className="block w-full pl-10 pr-3 py-3 border border-charcoal/10 rounded-xl bg-light focus:outline-none focus:ring-2 focus:ring-amber focus:border-transparent font-body transition-all" placeholder="you@example.com" data-id="element-591" />
            </div>
          </div>

          <div data-id="element-592">
            <div className="flex justify-between items-center mb-2" data-id="element-593">
              <label className="block font-heading text-sm text-charcoal uppercase tracking-wide" data-id="element-594">
                Password
              </label>
              <button type="button" className="font-body text-sm text-amber hover:underline" data-id="element-595">
                Forgot Password?
              </button>
            </div>
            <div className="relative" data-id="element-596">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-597">
                <LockIcon className="h-5 w-5 text-charcoal/40" data-id="element-598" />
              </div>
              <input type={showPassword ? 'text' : 'password'} className="block w-full pl-10 pr-10 py-3 border border-charcoal/10 rounded-xl bg-light focus:outline-none focus:ring-2 focus:ring-amber focus:border-transparent font-body transition-all" placeholder="••••••••" data-id="element-599" />
              <button type="button" onClick={() => setShowPassword(!showPassword)} className="absolute inset-y-0 right-0 pr-3 flex items-center text-charcoal/40 hover:text-charcoal transition-colors" data-id="element-600">
                {showPassword ? <EyeOffIcon className="h-5 w-5" data-id="element-601" /> : <EyeIcon className="h-5 w-5" data-id="element-602" />}
              </button>
            </div>
          </div>

          <button type="submit" className="w-full bg-victory-red hover:bg-red-700 text-white font-heading text-xl py-4 rounded-xl shadow-lg transition-colors uppercase tracking-wider" data-id="element-603">
            Sign In
          </button>
        </form>

        <div className="mt-8" data-id="element-604">
          <div className="relative" data-id="element-605">
            <div className="absolute inset-0 flex items-center" data-id="element-606">
              <div className="w-full border-t border-charcoal/10" data-id="element-607" />
            </div>
            <div className="relative flex justify-center text-sm" data-id="element-608">
              <span className="px-2 bg-white text-charcoal/40 font-heading uppercase tracking-widest" data-id="element-609">
                Or
              </span>
            </div>
          </div>

          <div className="mt-6" data-id="element-610">
            <button onClick={() => onNavigate('menu')} className="w-full bg-white border-2 border-charcoal/10 hover:border-charcoal/30 text-charcoal font-heading text-lg py-3 rounded-xl transition-colors uppercase tracking-wider" data-id="element-611">
              Continue as Guest
            </button>
          </div>
        </div>

        <p className="mt-8 text-center font-body text-charcoal/60" data-id="element-612">
          Don't have an account?{' '}
          <button onClick={() => onNavigate('signup')} className="text-amber font-bold hover:underline" data-id="element-613">
            Sign Up
          </button>
        </p>
      </div>
    </motion.div>;
}